import {
    REQUEST_DATA,
    REQUEST_FAILURE,
    REQUEST_SUCCESS,
} from './nonRunners.actions';

const initialState = {
    isFetching: false,
    data: [],
};

export default function nonRunnersReducer(state = initialState, action) {
    switch (action.type) {
        case REQUEST_DATA:
            return {
                ...state,
                isFetching: true,
            };
        case REQUEST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                data: action.data,
            };
        case REQUEST_FAILURE:
            return {
                ...state,
                isFetching: false,
                data: [],
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/nonRunners/nonRunners.reducer.js